/** A helper class to spread the event to additional event handlers added from external sources. */
export class EventHandler<Type> {
  private callbacks: Array<(arg: Type) => void>;

  /** Returns the added callback on success or null, if something went wrong. */
  public add<Callback extends (arg: Type) => void>(callback: Callback): Callback | null {
    const cb = this.callbacks.find((cb) => cb === callback);
    if (cb) return null;
    this.callbacks.push(callback);
    return callback;
  }

  /** Returns true if the input callback has been found and removed and false if not. */
  public remove<Callback extends (arg: Type) => void>(callback: Callback): boolean {
    const cb = this.callbacks.find((cb) => cb === callback);
    if (cb) this.callbacks.splice(this.callbacks.indexOf(cb), 1);
    return !!cb;
  }

  constructor() {
    this.callbacks = new Array<(arg: Type) => void>();
  }

  /** Emits the event-data for each of the existing handlers. */
  public static Emit<Type>(handler: EventHandler<Type>, event: Type): void {
    handler.callbacks.forEach((callback) => callback(event));
  }
}
